import React, { useContext, useEffect, useRef } from "react";
import useRefsInit from "../hooks/useRefsInit.jsx";
import BryntumContext from "../context/bryntumContext.jsx";
import { callOnLoadOnColumns } from "../../other/utils/otherUtils.jsx";
import ResourcesGridView from "../components/ResourcesGridView.jsx";
import {swivuCheckGridGrants} from "../../other/utils/utils.jsx";
import AuthContext from "../context/authContext.jsx";
import useEnableViewTracking from "../hooks/useEnableViewTracking.jsx";
import {ENTITY_TYPES, VIEW_TYPES} from "../../other/constants/OtherKeys.jsx";
import {GRANTS} from "../../other/constants/PrivilegeTypes.jsx";
import ViewSpecificHeader from "../components/appHeader/ViewSpecificHeader.jsx";
import { useSwivuKanban } from "../hooks/useSwivuKanban";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { KanbanWrapper } from "@/modern/components/kanban-wrapper";

const ResourcePage = () => {
  const resourceViewRef = useRef(null);
  const { setRefs, isRefsInit } = useRefsInit([resourceViewRef]);
  const { user } = useContext(AuthContext);
  const { project, editorHandler, viewManager, entityManager } = useContext(BryntumContext);
  const kanban = useSwivuKanban({ gridRef: resourceViewRef, storeId: STORE_KEYS.resourceStore, entityType: ENTITY_TYPES.RESOURCE });

  useEnableViewTracking(resourceViewRef, VIEW_TYPES.resources, isRefsInit);

  useEffect(() => {
    if (project) {
      // Assign custom project store to the grid
      if (project.resourceStore) {
        resourceViewRef.current.instance.store = project.resourceStore;
        resourceViewRef.current.instance.store.relayAll(resourceViewRef.current.instance, 'swivuResourceStore');
        resourceViewRef.current.instance.onClickSwivuEditMessage = () => {
          viewManager.openAnonymousViewByType({ viewType: VIEW_TYPES.settings, viewName: 'Settings' });
        }
        swivuCheckGridGrants(resourceViewRef.current.instance, user);
        callOnLoadOnColumns(resourceViewRef.current.instance.columns, project, { editorHandler, user, viewManager });
      }
    }
  }, [resourceViewRef, project, user, editorHandler, viewManager]);

  useEffect(() => {
    if (project?.resourceStore) {
      resourceViewRef.current.instance.onClickSwivuUserEditMessage = () => {
        if (user && user.can(GRANTS.grant_four)) {
          viewManager.selectView(viewManager.getDefaultViewByType(VIEW_TYPES.users));
        }
      }
    }
  }, [project, viewManager]);

  return (
    <>
      <ViewSpecificHeader
        viewToggleButtonConfig={{
          isKanbanMode: kanban.isKanbanMode,
          handleOnToggleView: kanban.handleOnToggleView,
          isGroupingApplied: kanban.isGroupingApplied,
          applyGroupingAndOpenKanban: kanban.applyGroupingAndOpenKanban,
          kanbanFieldConfig: kanban.kanbanFieldConfig,
          activeConfig: kanban.activeConfig,
          getActiveGroupOrder: kanban.getActiveGroupOrder,
          openCardFieldsEditor: kanban.openCardFieldsEditor
        }}
      />
      <KanbanWrapper
        {...kanban}
        onItemDblClick={(record) => {
          entityManager.openEntityManager({ entityType: ENTITY_TYPES.RESOURCE, entityId: record.id });
        }}
        grid={resourceViewRef.current?.instance}
        processCellMenuItems={resourceViewRef.current?.instance?.features?.cellMenu?.processItems}
      />
      <ResourcesGridView
        stateId
        ref={setRefs(resourceViewRef)}
        searchFeature={true}
      />
    </>
  );
};

export default ResourcePage;
